import database_es from './db/database_es';
import database_en from './db/database_en';

export const getLang = () => {
  const savedLang = localStorage.getItem('user_lang') || 'es';
  const data = savedLang === 'es' ? database_es : database_en;
  return { lang: savedLang, d: data };
};

export const setLang = () => {};
